export const BANNER_LINK_ACTION_SUBJECT_ID = 'jiraDashboardsBannerLink';
